<template>
	<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg
		id="Layer_1"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 529.3 129.5"
		style="enable-background:new 0 0 529.3 129.5;"
		xml:space="preserve"
	>
		<path
			class="st0"
			d="M119.9,122.7l5.3,6.4c0.4,0.5,1.1,0.6,1.6,0.2c20.1-15,31.9-38.5,31.9-63.6c0-24.9-11.6-48.2-31.4-63.2
	c-0.9-0.7-1.8-0.5-2.2,0.1l-5.2,6.2c-0.7,0.8-0.3,1.8,0.2,2.2c17.3,12.9,27.5,33.1,27.5,54.8c0,21.6-10.2,41.8-27.5,54.7
	C119.3,121,119.3,122,119.9,122.7"
		/>
		<path
			class="st1"
			d="M105.3,105.3l5.4,6.4c0.4,0.5,1.1,0.6,1.6,0.2c15-10.7,23.9-27.8,23.9-46.3c0-18.3-8.7-35.3-23.5-46
	c-0.8-0.5-1.6-0.4-2.1,0.1l-5.2,6.2c-0.8,1-0.2,2,0.4,2.4c12.1,8.6,19.3,22.4,19.3,37.3s-7.2,28.8-19.4,37.4
	C104.8,103.6,104.9,104.8,105.3,105.3"
		/>
		<path
			class="st2"
			d="M77,71.5L62.2,53.8c-0.8-1-2.1-1.1-2.8,0.2c-2.1,3.5-3.1,7.5-3.1,11.6c0,8.1,4.3,15.6,11.2,19.8
	c1,0.6,1,1.9,0.4,2.5l-5.3,6.3c-0.4,0.5-1,0.6-1.5,0.2c-9.9-6.3-15.9-17.2-15.9-28.9c0-10.5,4.8-20.3,12.9-26.8
	c2.3-1.9,4.7-1.7,6.1,0l14.7,17.5c0.1,0.2,0.3,0.3,0.5,0.3l0,0l0,0c0.2,0,0.4-0.1,0.5-0.3l14.7-17.5c1.4-1.7,3.7-1.9,6.1,0
	c8.1,6.5,12.9,16.3,12.9,26.8c0,11.7-6,22.6-15.9,28.9c-0.5,0.3-1.1,0.2-1.5-0.2L90.8,88c-0.6-0.6-0.6-2,0.4-2.5
	c6.9-4.2,11.2-11.7,11.2-19.8c0-4.1-1.1-8.1-3.1-11.6c-0.8-1.3-2.1-1.2-2.8-0.2L81.7,71.5c-0.6,0.7-1.5,1.1-2.3,1.1
	C78.5,72.6,77.6,72.2,77,71.5"
		/>
		<path
			class="st0"
			d="M38.8,122.7l-5.3,6.4c-0.4,0.5-1.1,0.6-1.6,0.2C11.8,114.2,0,90.7,0,65.6C0,40.7,11.6,17.5,31.4,2.4
	c0.9-0.7,1.8-0.5,2.2,0.1l5.2,6.2c0.7,0.8,0.3,1.8-0.2,2.2C21.3,23.8,11.1,44,11.1,65.6s10.2,41.8,27.5,54.7
	C39.4,121,39.4,122,38.8,122.7"
		/>
		<path
			class="st1"
			d="M53.3,105.3l-5.4,6.4c-0.4,0.5-1.1,0.6-1.6,0.2c-15-10.7-23.8-27.8-23.8-46.3c0-18.3,8.7-35.3,23.5-46
	c0.8-0.5,1.6-0.4,2.1,0.1l5.2,6.2c0.8,1,0.2,2-0.4,2.4c-12.1,8.6-19.3,22.4-19.3,37.3S40.8,94.4,53,103
	C53.9,103.6,53.8,104.8,53.3,105.3"
		/>
		<path
			:class="['transition-all st3', showText ? 'visible' : 'invisible']"
			d="M512.4,102v10h3.8c1.4,0,2.8-0.3,3.8-1.3c1-0.9,1.4-2.2,1.4-3.6s-0.3-2.7-1.4-3.6c-1-1-2.3-1.4-3.7-1.4h-4V102
	H512.4z M435,108h4.1l-2.1-4.2L435,108z M393.1,104.7h6.4c0.5,0,0.9-0.1,1.3-0.3c0.2-0.2,0.3-0.6,0.3-0.9s-0.1-0.8-0.3-1
	c-0.3-0.2-0.9-0.3-1.3-0.3h-6.4V104.7z M393.1,111.9h7.1c0.6,0,1-0.1,1.5-0.5c0.3-0.5,0.5-0.9,0.5-1.5s-0.1-1-0.5-1.5
	c-0.3-0.3-0.9-0.6-1.5-0.6h-7.1V111.9z M353,102v10h3.8c1.4,0,2.8-0.3,3.8-1.3c1-0.9,1.4-2.2,1.4-3.6s-0.3-2.7-1.4-3.6
	c-1-1-2.3-1.4-3.7-1.4h-4V102H353z M315.2,108h4.1l-2.1-4.2L315.2,108z M278.2,112.4c1.4,0,2.7-0.5,3.6-1.5c1-1,1.4-2.3,1.4-3.8
	s-0.5-2.8-1.4-3.8s-2.2-1.5-3.6-1.5s-2.7,0.5-3.6,1.5c-1,1-1.4,2.3-1.4,3.8s0.5,2.8,1.4,3.8S276.8,112.4,278.2,112.4z M235,105.4
	h5.8c0.6,0,1.2-0.1,1.6-0.5c0.3-0.3,0.5-0.8,0.5-1.3s-0.1-0.9-0.5-1.3c-0.5-0.3-1-0.5-1.5-0.5H235V105.4L235,105.4z M194.4,104.7
	h6.4c0.5,0,0.9-0.1,1.3-0.3c0.2-0.2,0.3-0.6,0.3-0.9s-0.1-0.8-0.3-1c-0.3-0.2-0.9-0.3-1.3-0.3h-6.4V104.7z M194.4,111.9h7.1
	c0.6,0,1-0.1,1.5-0.5c0.3-0.5,0.5-0.9,0.5-1.5s-0.1-1-0.5-1.5c-0.3-0.3-0.9-0.6-1.5-0.6h-7.1V111.9z M516.2,98.7
	c2.3,0,4.5,0.7,6.2,2.3c1.6,1.6,2.3,3.6,2.3,5.9s-0.7,4.3-2.3,5.9c-1.7,1.6-4,2.2-6.3,2.2H509V98.7H516.2z M480.1,108.7v-9.9h3.4
	v16.4h-2.1l-8.6-9.9v9.9h-3.4V98.7h2.1L480.1,108.7z M440.8,111.2h-7.3l-2,4h-3.7l8-16.4h2.4l8.2,16.4h-3.7L440.8,111.2z
	M403.7,105.9c0.5,0.3,0.9,0.8,1.3,1.4c0.5,0.8,0.7,1.7,0.7,2.7c0,1.5-0.5,2.8-1.6,3.8c-1.2,1-2.7,1.4-4.2,1.4h-10V98.7h9.6
	c1.3,0,2.8,0.2,3.8,1.2c1,0.8,1.4,2.1,1.4,3.4c0,0.7-0.1,1.3-0.5,2C403.9,105.4,403.8,105.6,403.7,105.9z M356.7,98.7
	c2.3,0,4.5,0.7,6.2,2.3c1.6,1.6,2.3,3.6,2.3,5.9s-0.7,4.3-2.3,5.9c-1.7,1.6-4,2.2-6.3,2.2h-7V98.7H356.7z M320.9,111.2h-7.3l-2,4
	h-3.7l8-16.4h2.4l8.2,16.4h-3.7L320.9,111.2z M278.2,115.7c-2.3,0-4.4-0.8-6.1-2.4c-1.6-1.6-2.4-3.8-2.4-6.2s0.7-4.4,2.4-6.2
	c1.6-1.6,3.7-2.4,6.1-2.4c2.3,0,4.4,0.8,6.1,2.4c1.6,1.6,2.4,3.7,2.4,6.2c0,2.3-0.7,4.4-2.4,6.2
	C282.6,114.8,280.6,115.7,278.2,115.7z M243.2,108.3l3.8,6.9h-3.8l-3.7-6.5H235v6.5h-3.4V98.7h9.3c1.4,0,2.8,0.3,4,1.3
	c1,0.9,1.5,2.2,1.5,3.6c0,1.2-0.3,2.3-1.2,3.3C244.8,107.6,244.1,108.1,243.2,108.3z M204.9,105.9c0.5,0.3,0.9,0.8,1.3,1.4
	c0.5,0.8,0.7,1.7,0.7,2.7c0,1.5-0.5,2.8-1.6,3.8c-1.2,1-2.7,1.4-4.2,1.4h-10V98.7h9.6c1.3,0,2.8,0.2,3.8,1.2c1,0.8,1.4,2.1,1.4,3.4
	c0,0.7-0.1,1.3-0.5,2C205.2,105.4,205.1,105.6,204.9,105.9z"
		/>
		<path
			:class="['transition-all st4', showText ? 'visible' : 'invisible']"
			d="M411.9,59.8h6.5h8.7c1.4,0,3.1-0.2,4.2-1.1c0.9-0.8,1.2-2,1.2-3.2s-0.3-2.4-1.2-3.2c-1-0.9-2.6-1.2-3.9-1.2
	h-12.8H412v8.7H411.9z M433.7,67.8L444,86h-10.4l-9.8-17.2H412V86h-9.2V59.8v-8.7v-8.9h9.2h15.5c3.8,0,7.6,0.9,10.5,3.5
	c2.8,2.5,4,5.9,4,9.6c0,3.3-1,6.2-3.1,8.7C437.4,65.8,435.7,67.1,433.7,67.8z M213.6,64.6l14.8-22.3h7.8V86H227V60.2l-13.4,20
	l-13.4-20V86H191V42.3h7.9L213.6,64.6z M353,42.3h8.9h26.4v8.9h-26.4v8.7h26.4v8.9h-26.4v8.4h26.4V86h-26.4H353v-8.9v-8.4v-8.9v-8.7
	V42.3z M303.9,42.3l13.7,29l13.7-29h9.8L320.4,86h-1.7h-2h-2l-20.6-43.7H303.9z M259.7,86l13.7-29l13.7,29h9.8l-20.6-43.7h-1.7h-2
	h-2L249.9,86H259.7z M456.7,86h9.3V42.3h-9.3V86z M491.5,42.3h-12l17.9,21.8L479.5,86h12l11.9-14.5L515.2,86h12L491.5,42.3z"
		/>
		<polygon
			:class="['transition-all st0', showText ? 'visible' : 'invisible']"
			points="524.2,42.3 509.5,60.3 511,62.2 527.3,42.3 "
		/>
		<polygon
			:class="['transition-all st1', showText ? 'visible' : 'invisible']"
			points="519.7,42.3 507.2,57.6 508.7,59.4 522.7,42.3 "
		/>
		<polygon
			:class="['transition-all st2', showText ? 'visible' : 'invisible']"
			points="518.2,42.3 506.5,56.7 505,54.8 515.2,42.3 "
		/>
	</svg>
</template>

<script setup lang="ts">
defineProps({
	showText: {
		type: Boolean,
		default: true
	}
})
</script>

<style scoped type="text/css">
.st0 {
	fill-rule: evenodd;
	clip-rule: evenodd;
	fill: #900C3F;
}

.st1 {
	fill-rule: evenodd;
	clip-rule: evenodd;
	fill: #C70039;
}

.st2 {
	fill-rule: evenodd;
	clip-rule: evenodd;
	fill: #FF5733;
}

.st3 {
	fill-rule: evenodd;
	clip-rule: evenodd;
}

.st4 {
	fill-rule: evenodd;
	clip-rule: evenodd;
	fill: #1A1A1A;
}

.dark .st0, .dark .st1, .dark .st2, .dark .st3, .dark .st4 {
	fill: #fff;
}
</style>
